/**
 * 全局 API 错误 toast · 一处订阅 · 自动按 HTTP status 翻成友好中文.
 *
 * 挂载位置: main.tsx 的 <AntdApp> 内 · 必须在 antd App context 下才能调
 * message.error.
 *
 * 行为:
 *   - axios 任意请求失败 → 自动 toast humanizeApiError(error, ctx)
 *   - 该请求 config 设 _silentError=true → 不 toast (页面自己处理)
 *   - 该请求 config 设 _errorContext="签字失败" → toast 前缀加上 context
 */
import { App } from "antd";
import { useEffect } from "react";

import { humanizeApiError, onApiError } from "@/utils/api-error";

export function GlobalApiErrorToast() {
  const { message } = App.useApp();

  useEffect(() => {
    return onApiError(({ error, context }) => {
      const friendly = humanizeApiError(error, context ?? "操作失败");
      const text = context ? `${context} · ${friendly}` : friendly;
      // 同一文案 1.5s 内去重 (避免 React StrictMode 双调 + 双 listener)
      message.error({ content: text, key: `api-err:${text}`, duration: 3 });
    });
  }, [message]);

  return null;
}
